<div *ngIf="showDialog" class="overlay"></div>
<nav href="#home" class="navbar navbar-style-two navbar-expand-lg navbar-light bg-light">
    <div class="container">
        <a class="navbar-brand" routerLink="/home-prince">
            <img src="assets/img/LogoPrinceBuonoPiccolo.png" alt="image"><p style="width: auto; color: rgb(164, 145, 36); margin-left: -74px;">Pratiche Auto - Moto - Nautica</p>
        </a>
        <!-- <a class="navbar-brand" routerLink="/home-prince">
            <img style=max-width:69%; src="assets/img/secondPartLogo.PNG" alt="image">
        </a> -->

        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
        </button>

        <div class="collapse navbar-collapse" id="navbarSupportedContent">
            <ul class="navbar-nav">
                <li class="nav-item"><a class="nav-link active" href="#home" (click)="trackLinkClick('Home')">Home</a></li>
                <li class="nav-item"><a class="nav-link" href="#about" (click)="trackLinkClick('About')">About</a></li>
                <li class="nav-item"><a class="nav-link" href="#services" (click)="trackLinkClick('Servizi')">Servizi</a></li>
                <li class="nav-item"><a class="nav-link" href="#news" (click)="trackLinkClick('News')">News</a></li>
                <li class="nav-item"><a class="nav-link" href="#contact" (click)="trackLinkClick('Contattaci')">Contattaci</a></li>
                <li class="nav-item"><a class="nav-link" href="#maps" (click)="trackLinkClick('DoveSiamo')">DoveSiamo</a></li>
            </ul>
            <!-- <div class="others-option">
                <a href="#contact" class="default-btn">Get Started</a>
            </div> -->
            <!-- <div class="others-option">
                <a style="width: auto; color: rgb(164, 145, 36);margin-right: -221px;
                font-size: 27px;">AGENZIA PRINCIPE</a>
            </div> -->
        </div>
        <div style="margin-left: 76px; margin-right: -90px;">
            <a class="navbar-brand" routerLink="/home-prince">
                <img src="assets/img/NomeInPalla.png" alt="image">
            </a>
        </div>
        <app-banner></app-banner>
    </div>
</nav>

<div class="home-slides-two owl-carousel owl-theme">
    <div class="main-banner banner-Background1">
        <div class="d-table">
            <div class="d-table-cell">
                <div class="container">
                    <div class="home-banner-content">
                        <h1 data-shadow=''>Agenzia Principe</h1>
                        <p style="font-weight:bold; font-size:26px">Agenzia Principe ha l'obiettivo di aiutare automobilisti e cittadini con servizi rapidi e efficaci</p>
                        <a href="#contact" class="default-btn">Contattaci</a>
                    </div>
                </div>
            </div>
        </div>

        <div class="scroll-btn">
            <a href="#about">
                <span class="mouse">
                    <span></span>
                </span>
            </a>
        </div>
    </div>

    <div class="main-banner banner-Barca">
        <div class="d-table">
            <div class="d-table-cell">
                <div class="container">
                    <div class="home-banner-content2" style="margin-top: 20% ; margin-left:20%">
                        <h1 data-shadow='' style="color:rgb(16, 144, 187)">Pratiche STED</h1>
                        <p style="color:rgb(16, 144, 187); font-weight:bold; font-size:26px" >Sportello Telematico del Diportista per risolvere ogni tua esigenza in termini di pratiche nautiche.</p>
                        <a href="#contact" class="default-btn">Contattaci</a>
                    </div>
                </div>
            </div>
        </div>

        <div class="scroll-btn">
            <a href="#about">
                <span class="mouse">
                    <span></span>
                </span>
            </a>
        </div>
    </div>

    <div class="main-banner banner-Background2">
        <div class="d-table">
            <div class="d-table-cell">
                <div class="container">
                    <div class="home-banner-content">
                        <h1 data-shadow=''>Pratiche Auto - Moto - Nautica</h1>
                        <p style="color:rgb(158, 103, 15); font-weight:bold; font-size:26px" >Siamo in grado di fornirvi servizi per gestire e risolvere i vari problemi burocratici legati al mondo dell'automotive e della nautica.</p>
                        <a href="#contact" class="default-btn">Contattaci</a>
                    </div>
                </div>
            </div>
        </div>

        <div class="scroll-btn">
            <a href="#about">
                <span class="mouse">
                    <span></span>
                </span>
            </a>
        </div>
    </div>

    <div class="main-banner banner-3">
        <div class="d-table">
            <div class="d-table-cell">
                <div class="container">
                    <div class="home-banner-content">
                        <h1 data-shadow=''>Agenzia Principe è la soluzione professionale dedicata al privato e all'impresa</h1>
                        <p style="font-weight:bold">Dalle soluzioni burocratiche quotidiane ai consigli migliori nei vari settori: trasferimenti di proprietà, patenti auto e nautiche, rinnovi patenti, camera di commercio ed infinite altre applicazioni.</p>
                        <a href="#contact" class="default-btn">Contattaci</a>
                    </div>
                </div>
            </div>
        </div>

        <div class="scroll-btn">
            <a href="#about">
                <span class="mouse">
                    <span></span>
                </span>
            </a>
        </div>
    </div>
</div>

<section id="about" class="about-area ptb-120">
    <div class="container">
        <div class="section-title">
            <span class="sub-title">About Us</span>
            <h2>Leader nel settore delle pratiche Auto - Moto - Nautiche</h2>
        </div>

        <div class="row align-items-center">
            <div class="col-lg-8 col-md-12">
                <div class="about-content">
                    <p>Agenzia Principe, dal 1980 a Napoli è sinonimo di professionalità e competenza nel disbrigo di pratiche automobilistiche, richieste e rilascio di certificazioni e documenti di ogni tipo. Siamo la soluzione giusta per concessionari auto/moto, imprese del settore e privati alle prese con la burocrazia dei mezzi di trasporto.</p>

                    <div class="features-text">
                        <h4><i class="ri-check-line"></i> Sportello Telematico dell'Automobilista</h4>
                        <p>I nostri servizi consentono, in tempi brevi, di portare a termine tutte le formalità con il Pubblico Registro e la Motorizzazione:
                            trasferimenti di proprietà, patenti auto e nautiche, rinnovi patenti, camera di commercio ed infinite altre applicazioni.</p>
                    </div>

                    <div class="features-text">
                        <h4><i class="ri-check-line"></i> Assistenza diretta per le concessionarie</h4>
                        <p>Nel corso degli anni, grazie alle moderne tecnologie, alla intraprendenza ed alla esperienza acquisita , Agenzia Principe è arrivata ad annoverare la fiducia di una larga fascia di concessionari e commercianti, tra i più noti di Napoli con servizi puntuali, nel rispetto della riservatezza e di alta qualità.</p>
                    </div>

                    <a href="#contact" class="default-btn">Contattaci</a>
                </div>
            </div>

            <div class="col-lg-4 col-md-12">
                <div class="about-image">
                    <img src="assets/img/facciataUfficio.jpg" alt="image">
                </div>
            </div>
        </div>
    </div>
</section>

<section id="services" class="services-area pt-120 pb-90 bg-0f1d22">
    <div class="container">
        <div class="section-title">
            <span class="sub-title">Servizi</span>
            <h2>Offriamo servizi eccezionali</h2>
        </div>

        <div class="row">
            <div class="col-lg-4 col-sm-6 col-md-6">
                <div class="single-services-box">
                    <div class="icon">
                        <img width="70" height="70" src="assets/img/icons8-car-insurance-96.png" alt="image">
                    </div>
                    <h3>Rinnovo e pratiche patenti</h3>
                    <p>La durata delle patenti è fissata in relazione all’età del conducente e alla categoria della patente (salvo diversa limitazione riportata sul documento stesso). </p>
                    <!-- <a routerLink="/services-details" class="read-more-btn">Read More<i class="ri-arrow-right-s-line"></i></a> -->
                    <button mat-raised-button class="default-btn2" (click)="openInfoDialog('Rinnovo Patente', 'Tramite questo servizio, il processo sarà nettamente 
                    più semplice e rapido rispetto alla procedura standard che prevede di rivolgersi a un ufficio dell’ASL territoriale. 
                    Dovrai, infatti, recarti semplicemnete presso la nostra agenzia nei giorni stabiliti in cui è presente il medico legale preposto all’esecuzione della visita medica.')">Maggiori Info</button>
                </div>
            </div>

            <div class="col-lg-4 col-sm-6 col-md-6">
                <div class="single-services-box">
                    <div class="icon">
                        <img width="70" height="70" src="assets/img/icons8-car-tax-96.png" alt="image">
                    </div>
                    <h3>Bollo Auto</h3>
                    <p>Paga il bollo delle tue auto comodamente. Il nostro sistema di pagamento è veloce e sicuro: è necessario soltanto il numero di targa del veicolo.</p>
                    <button mat-raised-button class="default-btn2" (click)="openInfoDialog('Bollo Auto', 'Questa pratica è rivolta sia al semplice cittadino che deve pagare il bollo della sua vettura, sia alla grossa impresa di autotrasporto, autonoleggio, concessionaria di auto aventi grosse moli di tasse da saldare e necessità di verifiche maggiori per il loro pagamenti.
                    Il nostro sistema di pagamento è veloce e sicuro: è necessario soltanto il numero di targa del veicolo (tranne in caso di mancanze da parte dell’Agenzia Delle Entrate, in tal caso abbiamo bisogno anche dei documenti del veicolo) e sono necessari soltanto pochi minuti per il pagamento e la stampa della ricevuta. Garantiamo sui bolli effettuati presso la Nostra agenzia rintracciabilità dei pagamenti e attestazioni degli stessi in caso di verifica da parte dell’Ente accertatore.')">Maggiori Info</button>
                </div>
            </div>

            <div class="col-lg-4 col-sm-6 col-md-6">
                <div class="single-services-box">
                    <div class="icon">
                        <img width="70" height="70" src="assets/img/icons8-partnership-96.png" alt="image">
                    </div>
                    <h3>Trasferimento di Proprietà</h3>
                    <p>Presso le nostre agenzie potrai effettuare tutte le operazioni riguardanti il trasferimento di proprietà dei veicoli. Evita file e lunghe attese.</p>
                    <button mat-raised-button class="default-btn2" (click)="openInfoDialog('Passaggio di Proprietà', 'La pratica di passaggio di proprietà serve a trascrivere alla Motorizzazione e al PRA l’atto di vendita di un veicolo da un soggetto ad un altro. La nostra Agenzia offre una soluzione professionale e veloce per la gestione della pratica di Passaggio di proprietà, perché organizzata con una struttura all’avanguardia, dotata delle più moderne tecnologie aperte ai collegamenti telematici con le principali amministrazioni, che consentono, in tempi rapidissimi, il rilascio immediato dei documenti aggiornati.')">Maggiori Info</button>
                </div>
            </div>

            <div class="col-lg-4 col-sm-6 col-md-6">
                <div class="single-services-box">
                    <div class="icon">
                        <img width="70" height="70" src="assets/img/icons8-licence-plate-96.png" alt="image">
                    </div>
                    <h3>Immatricolazioni</h3>
                    <p>Devi immatricolare auto, motocicli, ciclomotori, auto aziendali, camion, caravan, carrelli da trasporto o qualsiasi veicolo che necessita di una targa?</p>
                    <button mat-raised-button class="default-btn2" (click)="openInfoDialog('Immatricolazioni', 'Quando acquisti un nuovo veicolo, il servizio di immatricolazione assegna al veicolo una nuova targa. 
                    Con questa procedura la targa assegnata viene iscritta per la prima volta negli archivi pubblici ANV e PRA. 
                    La nostra Agenzia, essendo Sportello Telematico dell’Automobilista (S.T.A.) può rilasciare in tempo reale:')">Maggiori Info</button>
                </div>
            </div>

            <div class="col-lg-4 col-sm-6 col-md-6">
                <div class="single-services-box">
                    <div class="icon">
                        <img width="70" height="70" src="assets/img/icons8-car-theft-96.png" alt="image">
                    </div>
                    <h3>Perdita di Possesso</h3>
                    <p>Cosa fare quando perdi il possesso di un veicolo per qualsiasi causa: furto, incendio, appropriazione indebita, truffa, fallimento, sequestro, confisca o sentenza del giudice.</p>
                    <button mat-raised-button class="default-btn2" (click)="openInfoDialog('Perdita di Possesso', 'In caso di furto della propria vettura, è bene effettuare la perdita di possesso di un veicolo, un documento che certifica al PRA l’avvenuto smarrimento del mezzo di proprietà, esentando dagli obblighi di pagamento previsti dalla normativa per il possesso. La richiesta può essere espletata direttamnte presso la nostra agenzia Principe che tramite lo Sportello Telematico dell’Automobilista potrà presentare i documenti necessari per la perdita di possesso e svolgere il tutto in poco tempo e senza attesa. Occorre presentare solo: ')">Maggiori Info</button>
                </div>
            </div>

            <div class="col-lg-4 col-sm-6 col-md-6">
                <div class="single-services-box">
                    <div class="icon">
                        <img width="70" height="70" src="assets/img/icons8-car-badge-96.png" alt="image">
                    </div>
                    <h3>Pratiche REVE per targhe estere</h3>
                    <p>Presso la nostra agenzia è possibile effettuare in tempi rapidi, ma soprattutto semplificando l'iter burocratico, la registrazione al PRA dei veicoli ESTERI!!</p>
                    <button mat-raised-button class="default-btn2" (click)="openInfoDialog('Pratiche veicoli Esteri', 'Dal 19 marzo 2022 tutti i cittadini stranieri, residenti in Italia, sono obbligati ad immatricolare in Italia i veicoli di loro proprietà già immatricolati all’estero, tramite inscrizione al REVE (Registro Veicoli Esteri). Rivolgiti alla nostra agenzia per il disbrigo di questo tipo di pratiche. ')">Maggiori Info</button>
                </div>
            </div>
        </div>
    </div>

    <div class="container">
        <div class="section-title">
            <span class="sub-title">Sportello Telematico del Diportista</span>
            <h2>Pratiche STED</h2>
        </div>
        <div class="row">

            <div class="col-lg-4 col-sm-6 col-md-6">
                <div class="single-services-box">
                    <div class="icon">
                        <img width="70" height="70" src="assets/img/icons8-cost-96.png" alt="image">
                    </div>
                    <h3>Passaggio di Proprietà</h3>
                    <p>Presso la nostra agenzia è possibile effettuare in tempi rapidi la registrazione con atto autenticato per il trasferimento di proprietà delle imbarcazioni!!</p>
                    <button mat-raised-button class="default-btn2" (click)="openInfoDialog('Passaggio di Proprietà STED', 'Dal 2021, il SISTE ha informatizzato i Registri di iscrizione delle imbarcazioni e navi da diporto e digitalizzato il rilascio dei documenti di navigazione delle stesse. Le unità da diporto, con lunghezza superiore a 10m e fino a 24 m, rientrano nella categoria dei beni mobili registrati e come tali necessitano formalizzare il trasferimento della proprietà, con un atto di vendita redatto ed autenticato da uno sportello STED ')">Maggiori Info</button>
                </div>
            </div>

            <div class="col-lg-4 col-sm-6 col-md-6">
                <div class="single-services-box">
                    <div class="icon">
                        <img width="70" height="70" src="assets/img/icons8-license-96.png" alt="image">
                    </div>
                    <h3>Rinnovo patenti nautiche</h3>
                    <p>Rivolgiti al nostro ufficio per il rinnovo della tua patente nautica, indipendentemente da quale ufficio sia stata rilasciata</p>
                    <button mat-raised-button class="default-btn2" (click)="openInfoDialog('RINNOVO PATENTI NAUTICHE', 'Presso la nostra Agenzia possiamo effettuare la visita medica per il rinnovo della patente per la conduzione delle imbarcazioni, previo appuntamento la visita verrà effettuata da un medico competente presso la nostra sede. Saranno necessari i seguenti documenti:  ')">Maggiori Info</button>
                </div>
            </div>

            <div class="col-lg-4 col-sm-6 col-md-6">
                <div class="single-services-box">
                    <div class="icon">
                        <img width="70" height="70" src="assets/img/icons8-secure-96.png" alt="image">
                    </div>
                    <h3>Rinnovo del certificato di sicurezza</h3>
                    <p>In tempi rapidi, ma soprattutto semplificando l'iter burocratico, potrai rinnovare il tuo certificato di sicurezza</p>
                    <button mat-raised-button class="default-btn2" (click)="openInfoDialog('Rinnovo del certificato di sicurezza', 'Tutte le imbarcazioni iscritte nei registri tramite lo sportello telematico del diportista STED hanno l’obbligo di rinnovare il certificato di sicurezza. Presso la nostra agenzia potrai ricevere questo servizio in tempi brevi ')">Maggiori Info</button>
                </div>
            </div>
        </div>
    </div>
</section>

<!-- <section class="funfacts-area pt-120 pb-90 jarallax" data-jarallax='{"speed": 0.3}'>
    <div class="container">
        <div class="row">
            <div class="col-lg-3 col-md-3 col-sm-6">
                <div class="single-funfacts">
                    <i class="ri-briefcase-line"></i>
                    <p>Projects Completed</p>
                    <h3 class="odometer" data-count="5421">00</h3>
                </div>
            </div>

            <div class="col-lg-3 col-md-3 col-sm-6">
                <div class="single-funfacts">
                    <i class="ri-group-2-line"></i>
                    <p>Happy Clients</p>
                    <h3 class="odometer" data-count="4579">00</h3>
                </div>
            </div>
            
            <div class="col-lg-3 col-md-3 col-sm-6">
                <div class="single-funfacts">
                    <i class="ri-cup-line"></i>
                    <p>Cup of Coffee</p>
                    <h3 class="odometer" data-count="499">00</h3>
                </div>
            </div>
            
            <div class="col-lg-3 col-md-3 col-sm-6">
                <div class="single-funfacts">
                    <i class="ri-trophy-line"></i>
                    <p>My Awards</p>
                    <h3 class="odometer" data-count="52">00</h3>
                </div>
            </div>
        </div>
    </div>

    <div class="lines">
        <div class="line"></div>
        <div class="line"></div>
        <div class="line"></div>
    </div>
</section> -->

<!-- <section id="portfolio" class="works-area pt-120 pb-90">
    <div class="container">
        <div class="section-title">
            <span class="sub-title">Works</span>
            <h2>Some of Our Creative Projects</h2>
        </div>

        <div class="row">
            <div class="col-lg-4 col-md-4 col-sm-12">
                <div class="single-works-box">
                    <div class="works-image">
                        <img src="assets/img/works/img1.jpg" alt="image">
                        <div class="overlay"></div>
                        <a routerLink="/works-details" class="link-btn"></a>
                    </div>

                    <div class="works-content">
                        <h3><a routerLink="/works-details">Festival Banner</a></h3>
                        <ul>
                            <li><a href="#">Web</a></li>
                            <li><a href="#">Banner</a></li>
                        </ul>
                    </div>
                </div>
            </div>

            <div class="col-lg-8 col-md-8 col-sm-12">
                <div class="single-works-box">
                    <div class="works-image">
                        <img src="assets/img/works/img2.jpg" alt="image">
                        <div class="overlay"></div>
                        <a routerLink="/works-details" class="link-btn"></a>
                    </div>

                    <div class="works-content">
                        <h3><a routerLink="/works-details">Book Cover Presentation</a></h3>
                        <ul>
                            <li><a href="#">Design</a></li>
                            <li><a href="#">Book</a></li>
                        </ul>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="single-works-box">
                    <div class="works-image">
                        <img src="assets/img/works/img3.jpg" alt="image">
                        <div class="overlay"></div>
                        <a routerLink="/works-details" class="link-btn"></a>
                    </div>

                    <div class="works-content">
                        <h3><a routerLink="/works-details">Poster Vector</a></h3>
                        <ul>
                            <li><a href="#">HTML</a></li>
                            <li><a href="#">CSS</a></li>
                        </ul>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="single-works-box">
                    <div class="works-image">
                        <img src="assets/img/works/img4.jpg" alt="image">
                        <div class="overlay"></div>
                        <a routerLink="/works-details" class="link-btn"></a>
                    </div>

                    <div class="works-content">
                        <h3><a routerLink="/works-details">Content Writing</a></h3>
                        <ul>
                            <li><a href="#">Web</a></li>
                            <li><a href="#">Text</a></li>
                        </ul>
                    </div>
                </div>
            </div>
            
            <div class="col-lg-4 col-md-6 col-sm-6 offset-lg-0 offset-md-3 offset-sm-3">
                <div class="single-works-box">
                    <div class="works-image">
                        <img src="assets/img/works/img5.jpg" alt="image">
                        <div class="overlay"></div>
                        <a routerLink="/works-details" class="link-btn"></a>
                    </div>

                    <div class="works-content">
                        <h3><a routerLink="/works-details">Digital Marketing</a></h3>
                        <ul>
                            <li><a href="#">Web</a></li>
                            <li><a href="#">HTML</a></li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section> -->

<section class="feedback-area">
    <div class="container-fluid">
        <div class="row">
            <div class="col-lg-5 col-md-12">
                <div class="feedback-content jarallax" data-jarallax='{"speed": 0.3}'>
                    <div class="d-table">
                        <div class="d-table-cell">
                            <div class="section-title">
                                <span class="sub-title">Testimonials</span>
                                <h2>Cosa dicono di noi i clienti</h2>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-lg-7 col-md-12">
                <div class="feedback-slides-content lr-padding bg-0f1d22">
                    <div class="feedback-slides owl-carousel owl-theme">
                        <div class="single-feedback-item">
                            <i class="ri-double-quotes-r"></i>
                            <p>Ho Fatto il rinnovo di patente lunedì 17.oggi 20 luglio mi e arrivata, qualche mese fa fatto un passaggio di proprietà rapidi e veloci disponibili e preparati consiglio 100 100 quest agenzia soddisfatto</p>

                            <div class="client-info">
                                <h3>C. P.</h3>
                                <span>Recenzione di Google</span>
                            </div>
                        </div>

                        <div class="single-feedback-item">
                            <i class="ri-double-quotes-r"></i>
                            <p>Mi sono trovato molto bene, il personale è molto serio e qualificato e in poco tempo hanno risolto il mio problema. Grazie e alla prossima.</p>

                            <div class="client-info">
                                <h3>Luca Tornincasa</h3>
                                <span>Recensione di Google</span>
                            </div>
                        </div>

                        <div class="single-feedback-item">
                            <i class="ri-double-quotes-r"></i>
                            <p>Mi sono trovato bene in questa agenzia. I tempi per le pratiche sono molto ragionevoli</p>

                            <div class="client-info">
                                <h3>A. G.</h3>
                                <span>Recensione di Google</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="team-area ptb-120">
    <div class="container">
        <div class="section-title">
            <span class="sub-title">Team</span>
            <h2>Amazing Team</h2>
        </div>

        <div class="team-slides owl-carousel owl-theme">
            <div class="single-team-box">
                <img src="assets/img/team/Cosimo2.png" alt="image">

                <div class="team-content">
                    <h3>Cosimo Principe</h3>
                    <span>Fondatore</span>
                </div>
            </div>

            <div class="single-team-box">
                <img src="assets/img/team/Sara2.png" alt="image">

                <div class="team-content">
                    <h3>Sara Gargiulo</h3>
                    <span>Collaboratrice</span>
                </div>
            </div>
å
            <div class="single-team-box">
                <img src="assets/img/team/Camilla.png" alt="image">

                <div class="team-content">
                    <h3>Camilla Principe</h3>
                    <span>Collaboratrice</span>
                </div>
            </div>

            <!-- <div class="single-team-box">
                <img src="assets/img/team/img4.jpg" alt="image">

                <div class="team-content">
                    <h3>Luca Di Mattero</h3>
                    <span>QA Engineer</span>
                </div>
            </div> -->
        </div>
    </div>
</section>

<!-- <section class="hire-me-area bg-0f1d22 ptb-120">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-7 col-md-12">
                <div class="hire-me-content">
                    <span class="sub-title">Have You Any Project?</span>
                    <h2>Build Your Awesome Websites</h2>
                </div>
            </div>

            <div class="col-lg-5 col-md-12">
                <div class="hire-me-btn">
                    <a href="#contact" class="default-btn">Start a Project</a>
                </div>
            </div>
        </div>
    </div>
</section> -->

<section id="news" class="blog-area pt-120 pb-90">
    <div class="container">
        <div class="section-title">
            <span class="sub-title">Blog</span>
            <h2>Scopr le ultime novità</h2>
        </div>

        <div class="row">
            <div class="col-lg-4 col-md-6" *ngFor="let newsItem of latestNews; let i = index">
                <div class="single-blog-post" *ngIf="i < 3">
                    <div class="post-image">
                        <a routerLink="/blog-details">
                           <img src="assets/img/news1.jpeg" alt="image" *ngIf="i==0">
                           <img src="assets/img/news2.jpg" alt="image" *ngIf="i==1">
                           <img src="assets/img/news3.jpg" alt="image" *ngIf="i==2">
                        </a>
                    </div>

                    <div class="post-content">
                        <ul class="post-tag">
                            <li><a href="https://www.aci.it/" target="_blank">ACI</a></li>
                            <!-- <li><a href="#">SEO</a></li>
                            <li><a href="#">Marketing</a></li> -->
                        </ul>

                        <h3><a href="{{newsItem.link}}" target="_blank">{{ newsItem.title }}</a></h3>

                        <div class="post-meta">
                            <ul>
                                <li>By ACI</li>
                                <li>{{formattaDataItaliano(newsItem.pubDate)}}</li>
                            </ul>
                            <!-- <a routerLink="/blog-details" class="details-btn"><i class="ri-arrow-right-s-line"></i></a> -->
                        </div>
                    </div>
                </div>
            </div>

            <!-- <div class="col-lg-4 col-md-6">
                <div class="single-blog-post">
                    <div class="post-image">
                        <a routerLink="/blog-details">
                            <img src="assets/img/blog/img2.jpg" alt="image">
                        </a>
                    </div>

                    <div class="post-content">
                        <ul class="post-tag">
                            <li><a href="#">HTML</a></li>
                            <li><a href="#">CSS</a></li>
                        </ul>

                        <h3><a routerLink="/blog-details">10 features your CMS absolutely needs</a></h3>

                        <div class="post-meta">
                            <ul>
                                <li>By <a href="#">John</a></li>
                                <li>20 February, 2020</li>
                            </ul>
                            <a routerLink="/blog-details" class="details-btn"><i class="ri-arrow-right-s-line"></i></a>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 col-md-6 offset-lg-0 offset-md-3">
                <div class="single-blog-post">
                    <div class="post-image">
                        <a routerLink="/blog-details">
                            <img src="assets/img/blog/img3.jpg" alt="image">
                        </a>
                    </div>

                    <div class="post-content">
                        <ul class="post-tag">
                            <li><a href="#">JS</a></li>
                            <li><a href="#">PHP</a></li>
                        </ul>

                        <h3><a routerLink="/blog-details">The beginner's guide to CSS classes</a></h3>

                        <div class="post-meta">
                            <ul>
                                <li>By <a href="#">John</a></li>
                                <li>19 February, 2020</li>
                            </ul>
                            <a routerLink="/blog-details" class="details-btn"><i class="ri-arrow-right-s-line"></i></a>
                        </div>
                    </div>
                </div>
            </div> -->
        </div>
    </div>
</section>

<section id="contact" class="contact-area">
    <div class="container-fluid">
        <div class="row">
            <div class="col-lg-5 col-md-12">
                <div class="contact-content jarallax" data-jarallax='{"speed": 0.3}'>
                    <div class="d-table">
                        <div class="d-table-cell">
                            <div class="section-title">
                                <span class="sub-title">Parliamone</span>
                                <h2>Mettiti in contatto con noi</h2>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-lg-7 col-md-12">
                <div class="contact-form lr-padding bg-0f1d22">
                    <form id="contactForm" 
                    [formGroup]="form"
                    (ngSubmit)="send()">
                        <div class="row">
                            <div class="col-lg-12 col-md-12">
                                <div class="form-group mb-3">
                                    <input formControlName="name" type="text" name="name" id="name" class="form-control" placeholder="Inserisci il tuo Nome">
                                </div>
                            </div>

                            <div class="col-lg-12 col-md-12">
                                <div class="form-group mb-3">
                                    <input type="email" formControlName="email" name="email" id="email" class="form-control" placeholder="Inserisci la tua Mail">
                                </div>
                            </div>

                            <div class="col-lg-12 col-md-12">
                                <div class="form-group mb-3">
                                    <textarea name="message" formControlName="message" class="form-control" id="message" cols="30" rows="5" placeholder="Scirvi il tuo messaggio"></textarea>
                                </div>
                            </div>

                            <div class="col-lg-12 col-md-12">
                                <div class="form-group mb-3">
                                    <input type="checkbox" formControlName="privacyConsent" id="privacyConsent">
                                    <label for="privacyConsent" style="color: white;">Ho letto e acconsento all'informativa sulla </label><a href="/privacy-policy" target="_blank"> privacy</a>
                                </div>
                                <div *ngIf="!form.get('privacyConsent').value" class="error-message" style="color: red;">
                                    Devi accettare l'informativa sulla privacy
                                </div>
                            </div>

                            <div class="col-lg-12 col-md-12">
                                <button type="submit" [disabled]="!form.valid || !form.get('privacyConsent').value" class="default-btn">Invia Messaggio</button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</section>

<!-- <section id="maps" class="about-area ptb-120">
    <div class="container">
        <div class="section-title">
            <span class="sub-title">Dove Siamo</span>
            <div style="display: inline;"> 
                <i class="ri-map-pin-line" style="color: navajowhite; font-size:30px"></i><h2 style="display: inline;">Vieni a trovarci</h2>
            </div>        
        </div>
    <agm-map [latitude]="lat" [longitude]="lng" [zoom]="zoom"  [scrollwheel]=null [gestureHandling]="'cooperative'">
        <agm-marker [latitude]="lat" [longitude]="lng"></agm-marker>
      </agm-map>
    </div>
</section> -->

<section id="maps" class="about-area ptb-120">
    <div class="container">
        <div class="section-title">
            <span class="sub-title">Dove Siamo</span>
            <div style="display: inline;"> 
                <i class="ri-map-pin-line" style="color: navajowhite; font-size:30px"></i><h2 style="display: inline;">Vieni a trovarci</h2>
            </div>        
        </div>
        <app-map></app-map>
    </div>
</section>

<footer class="footer-area">
    <div class="container">
        <div class="footer-content">
            <div class="logo">
                <a href="#home">
                    <img src="assets/img/LogoPrincePiccolo.png" alt="image">
                </a>
            </div>

            <div class="footer-contact-info">
                <ul>
                    <li><i class="ri-map-pin-line"></i> <a href="https://www.google.com/maps/place/Agenzia+Principe+di+Principe+Cosimo+Alberto/@40.8341533,14.2306373,18.25z/data=!4m6!3m5!1s0x133b0902476d39e9:0xa5831e5e56dd5ede!8m2!3d40.8343419!4d14.2314868!16s%2Fg%2F1tdjlwvv?hl=it&entry=ttu" target="_blank">Via Santa Maria in Portico, 50, Napoli, Chiaia</a></li>
                    <li><i class="ri-phone-line"></i> <a href="tel:+39 0810608201">(+39) 0810608201</a></li>
                    <li><i class="ri-printer-line"></i> <a href="tel:+39 0810608202">(+39) 0810608202</a></li>
                    <li><i class="ri-mail-line"></i> <a href="mailto:cosimoprincipe@yahoo.it">cosimoprincipe@yahoo.it</a></li>
                </ul>
            </div>

            <ul class="social">
                <li><a href="https://www.facebook.com/profile.php?id=100054275720773" target="_blank">Facebook</a></li>
                <li><a href="https://www.linkedin.com/in/cosimo-principe-60885988/" target="_blank">Linkedin</a></li>
                <li><a href="#" target="_blank">Instagram</a></li>
            </ul>
        </div>
    </div>

    <div class="footer-bottom-area">
        <div class="container">
            <p>© AgenziaPrincipe is Proudly Owned by <a href="https://www.linkedin.com/in/sergio-principe-51865350/" target="_blank">Sergio Principe</a></p>
        </div>

        <div class="line"></div>
    </div>
</footer>